import React from 'react';

export const CustomNextSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <circle
        cx="6"
        cy="6.3689"
        r="5"
        fill="#001E50"
        stroke="#001E50"
        stroke-width="2"
      />
    </svg>
  );
};
